import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const PUBLIC_PATH_PREFIXES = [
  '/login',
  '/profile-selection',
  '/forgot-password',
  '/reset-password',
  '/create-password',
  '/accept-t&c',
  '/unsubscribe',
  '/privacy-policy',
  '/support',
  '/termsandconditions',
];

let isRedirectingToLogin = false;

export type SessionEndReason = 'expired' | 'revoked';

/** Clear a terminal browser session and collapse concurrent failures to one reload. */
export const expireSessionAndRedirect = (
  reason: SessionEndReason = 'expired'
): void => {
  cookies.remove('user', { path: '/' });
  cookies.remove('super_user', { path: '/' });
  cookies.remove('original_company_id', { path: '/' });
  cookies.remove('token', { path: '/' });
  cookies.remove('role', { path: '/' });
  cookies.remove('settings', { path: '/' });

  if (typeof window === 'undefined' || !window.location) return;
  const pathname = window.location.pathname || '';
  const onPublicPage = PUBLIC_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix)
  );
  if (onPublicPage || isRedirectingToLogin) return;
  isRedirectingToLogin = true;
  window.location.assign(`/login?reason=${reason}`);
};
